import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Injectable({
  providedIn: 'root'
})
export class RouterUtils {

  constructor(private router: Router, private notification: NzNotificationService, private tanslateService: TranslateService) { }

  async afterPasswordChanged() {

    let seconds = 3;
    var title = await this.tanslateService.get("Login.ChangePasswordSuccess").toPromise();
    var messageTemplate: string = await this.tanslateService.get("Utils.ReturnToLoginAfter").toPromise();
    var messageAccessor = (_: number) => messageTemplate.replace("{0}", _.toString());
    const modal = this.notification.success(title, messageAccessor(seconds), {
      nzKey: 'key',
      nzDuration: 3000
    });
    const intervalId: any = setInterval(() => {
      this.notification.success(title, messageAccessor(seconds), {
        nzKey: 'key'
      });
    }, 1000);
    modal.onClose.asObservable().subscribe(() => {
      window.clearInterval(intervalId);
      this.router.navigate(['login']);
    });
    localStorage.removeItem('userinfo');
    localStorage.removeItem('token');
  }
}
